var map = {
	"./2.png": 750943,
	"./2.webp": 420985,
	"./3.jpg": 447714,
	"./3.webp": 48560,
	"./4.jpg": 659500,
	"./4.webp": 69409,
	"./5.jpg": 427367,
	"./5.webp": 381430,
	"./9-1.jpg": 242346,
	"./9-1.webp": 549622,
	"./9-2.jpg": 345690,
	"./9-2.webp": 275389,
	"./D2M_EB_220W.png": 595545,
	"./D2M_EB_220W.webp": 774124,
	"./D2M_W2.png": 227743,
	"./D2M_W2.webp": 649934,
	"./D2_220W.png": 162461,
	"./D2_220W.webp": 246295,
	"./DP_400W.png": 621463,
	"./DP_400W.webp": 563940,
	"./R2P_220W.png": 359694,
	"./R2P_220W.webp": 707871,
	"./kv.jpg": 399106,
	"./kv.webp": 344060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 883162;